var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "push_admin",
    },
    [
      _c("div", { staticClass: "header_card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "header_channel" }, [
          _vm._v("\n      当前生效渠道："),
          _c("span", { staticClass: "channel_tag" }, [
            _vm._v(_vm._s(_vm.channelName)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config_card" },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "channel_box" }, [
            _c(
              "div",
              {
                staticClass: "channel_item",
                class: { active: _vm.activMode === 1 },
                on: {
                  click: function ($event) {
                    return _vm.onSelectChannel(1)
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "channel_logo jiguang",
                  attrs: {
                    src: require("../../../assets/jiguang.png"),
                    alt: "",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "channel_name" }, [
                  _vm._v("极光推送"),
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "radio_dot",
                  class: { checked: _vm.activMode === 1 },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "channel_item",
                class: { active: _vm.activMode === 2 },
                on: {
                  click: function ($event) {
                    return _vm.onSelectChannel(2)
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "channel_logo mob",
                  attrs: {
                    src: require("../../../assets/MobTech.png"),
                    alt: "",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "channel_name" }, [
                  _vm._v("Mob Tech"),
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "radio_dot",
                  class: { checked: _vm.activMode === 2 },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "backup_text" }, [_vm._v("服务方对接参数")]),
          _vm._v(" "),
          _c("pushConfig", {
            attrs: {
              "jguang-base-config": _vm.jguangBaseConfig,
              "activ-mode": _vm.activMode,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config_card" },
        [
          _c("pushSwitch", {
            attrs: { "jguang-base-config": _vm.jguangBaseConfig },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config_card" },
        [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              staticClass: "vendor_tabs",
              model: {
                value: _vm.activeVendor,
                callback: function ($$v) {
                  _vm.activeVendor = $$v
                },
                expression: "activeVendor",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "华为推送", name: "huawei" } },
                [
                  _c("pushHuaWeiConfig", {
                    attrs: { "huawei-config": _vm.huaweiConfig },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "OPPO推送", name: "oppo" } },
                [
                  _c("pushOppoConfig", {
                    attrs: { "oppo-config": _vm.oppoConfig },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "小米推送", name: "xiaomi" } },
                [
                  _c("pushXiaoMiConfig", {
                    attrs: { "xiaomi-config": _vm.xiaomiConfig },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "vivo推送", name: "vivo" } },
                [
                  _c("pushVivoConfig", {
                    attrs: { "vivo-config": _vm.vivoConfig },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "荣耀推送", name: "honor" } },
                [
                  _c("pushHonorConfig", {
                    attrs: { "honor-config": _vm.honorConfig },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "header_title" }, [_vm._v("消息推送配置")]),
      _vm._v(" "),
      _c("div", { staticClass: "header_desc" }, [
        _vm._v(
          "配置 App 的推送服务商与安卓厂商通道参数。保存后立即对新发起的推送任务生效。"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card_title" }, [
      _vm._v("\n      推送服务商与对接参数\n      "),
      _c("span", { staticClass: "warn_text" }, [
        _vm._v(
          "注意，服务商对接参数修改后，需打包才可生效，请勿随意修改配置信息！（切换服务商需重新打包）"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card_title" }, [
      _vm._v("\n      安卓厂商通道配置\n      "),
      _c("span", { staticClass: "warn_text" }, [
        _vm._v("注意，参数修改后，需重新打包才可生效，请勿随意修改配置信息！"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }